// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__L-Ioy","label":"BuildControl_label__2j7nI","More":"BuildControl_More__2Nb2j","Less":"BuildControl_Less__2NCzS"};